import { render, staticRenderFns } from "./ConfigWebsiteCatalogueValidation.vue?vue&type=template&id=6ccdef78&scoped=true"
import script from "./ConfigWebsiteCatalogueValidation.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueValidation.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueValidation.vue?vue&type=style&index=0&id=6ccdef78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccdef78",
  null
  
)

export default component.exports